import { render } from "./rights-user-overview.vue?vue&type=template&id=46d02856&ts=true"
import script from "./rights-user-overview.ts?vue&type=script&lang=ts&external"
export * from "./rights-user-overview.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__